import { render } from "./ChartTGEIndex.vue?vue&type=template&id=58696f7a&scoped=true"
import script from "./ChartTGEIndex.vue?vue&type=script&lang=js"
export * from "./ChartTGEIndex.vue?vue&type=script&lang=js"

import "./ChartTGEIndex.vue?vue&type=style&index=0&id=58696f7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58696f7a"]])

export default __exports__